<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="closeModal()">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container">
  <h1>{{addons[currentAddonIndex].i18nName[translate.currentLang.toUpperCase()]}}</h1>
  <div class="slide-controller" *ngIf="addons.length > 1">
    <ion-icon name="chevron-back-circle-outline" (click)="changeSlideAddon('prev')"></ion-icon>
    <div>
      <span class="slide-point" [class.current-slide-point]="currentAddonIndex === i" *ngFor="let item of addons; let i = index;"></span>
    </div>
    <ion-icon name="chevron-forward-circle-outline" (click)="changeSlideAddon('next')"></ion-icon>
  </div>
  <p class="description">
    {{addons[currentAddonIndex].i18nDescription[translate.currentLang.toUpperCase()]}}
  </p>
  <p class="price">
    {{addons[currentAddonIndex].price + addons[currentAddonIndex].currency}}
    <span class="qty">({{'ADDONS.QTY' | translate}}: {{addons[currentAddonIndex].quantity}})</span>
  </p>
</div>
